import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "dx-home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<nav class=\"dx-home-header\"><div class=\"dx-home-logo\"><img class=\"dx-logo-img\" src=\"" + _imports_0 + "\" alt=\"\" srcset=\"\"><h1>DXUI</h1></div><div class=\"dx-home-notice\">dxui组件库有了新的域名，dxui.cn</div><div class=\"dx-home-link\"><a class=\"dx-github-link\" href=\"https://github.com/757363985/dxui\" target=\"_blank\"><span class=\"icon-github\"></span></a></div></nav>", 1)
const _hoisted_3 = { class: "dx-home-content" }
const _hoisted_4 = { class: "dx-content-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "dx-nav-button" }, "组件名称", -1)
const _hoisted_6 = { class: "dx-nav-button" }
const _hoisted_7 = { class: "dx-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.componentsList, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.id,
            "active-class": "dx-nav-active-button",
            to: `/home/${item.id.toLowerCase()}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.id) + " " + _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}